<template>
  <div class="publicGoodList">
      <Dialog :customerDia.sync="customerDia" :hideOverSea='true' :distributeText='text'></Dialog>
      <transition name="hehe">
		   <customer-Chat v-if="showTrue" @closeDia="showTrue=false" :receiveItems="receiveItems" />
	   </transition>

       <div class="beifenxi">
           <el-dialog
            :visible.sync="dialogVisible"
            width="70%"
            >
            <div class="textDesc">{{$t('other.a1725')}}:
            {{$t('other.a1726')}} 
            <a style="color:#fff" href="https://www.weanaly.com/chrome-extension/download-crx">
                <el-button class="el-icon-download" type="primary">{{$t('other.a1727')}}</el-button>
                </a>
                </div>
            <template>
                <el-table
                :data="tableList"
                size='mini'
                border
                height='450'
                :default-sort = "{prop: 'surgeIndex', order: 'descending'}"
                style="width: 100%;height:450px">
                <el-table-column :label="$t('other.a1728')" width="100">
                    <template slot-scope="scope">
                    <div class="picbox" >
                        <img style="width:100%" :title="scope.row.name" :src="getImageUrlCopy(conturyCode,scope.row.image)" >
                    </div>
                    </template>
                </el-table-column>
                <el-table-column prop="surgeIndex" sortable :label="$t('other.a1729')">
                    <template slot-scope="scope">
                    <span>{{scope.row.surgeIndex}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a1730')" sortable>
                    <template slot-scope="scope">
                    <span>{{scope.row.sold}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a1731')" sortable>
                    <template slot-scope="scope">
                    <span>
                        {{
                        '¥' +
                            getMonthTotalSales(
                            scope.row.models,
                            scope.row.currency,
                            scope.row.price_max,
                            scope.row.price_min,
                            scope.row.sold,
                            )
                        }}
                    </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a1732')" sortable>
                    <template slot-scope="scope">
                    <span>{{getDayNum(scope.row.ctime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a1733')" sortable>
                    <template slot-scope="scope">
                    <span> ¥ {{getLatestRMBPrice(scope.row.price_min,scope.row.currency)}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a1734')" sortable>
                    <template slot-scope="scope">
                    <span>{{getConversionRate(scope.row.sold,scope.row.view_count)}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a33')" >
                    <template slot-scope="scope">
                    <el-button size="mini" type="primary"  @click="toGoodsDetailPage(scope.row.shopid, scope.row.itemid,scope.row.currency)">{{$t('other.a1735')}}</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">{{$t('other.a5')}}</el-button>
            </span>
            </el-dialog>
       </div>
      <div class="ghbyg">
          <div  class="desoring">
            <div class="yghu">
                <div class="ppom">
                    <span class="yubg" @mouseenter="show=true" @mouseleave="hideMore()">{{purchaseDesc}}</span>
                    <ul :class="{'ulbox':true,'showMore':show==true}" @mouseenter="show1=true" @mouseleave="hideMoreCopy()">
                        <li class="ingl">
                            <ul>
                                <li class="uiop" @click="getIndustria(null,0)">{{$t('other.a3100')}}</li>
                            </ul>
                        </li>
                        <li class="ingl">
                            <ul style="display:flex;flex-wrap: wrap;">
                                <li v-if="industrialbelt.length > 0" class="uiop" v-for="(p,index) in industrialbelt" :key="index" @click="getIndustria(p,0)">{{p.industrialBelt}}</li>
                                <li v-if="!industrialbelt.length" class="uiop" >{{$t('other.a3101')}}</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                    
            </div>
            <div class="yghu">
                <div class="ppom">
                    <span class="yubg" @mouseenter="showStore=true" @mouseleave="hideStore()">{{storeType}}</span>
                    <ul :class="{'ulbox':true,'showMore':showStore==true}" @mouseenter="showStore1=true" @mouseleave="hideStoreCopy()">
                        <li class="ingl">
                            <ul>
                                <li class="uiop" @click="getIndustria(null,1)">{{$t('other.a1846')}}</li>
                            </ul>
                        </li>
                        <li class="ingl">
                            <ul style="display:flex;flex-wrap: wrap;">
                                <li class="uiop"  v-for="(k,index) in storeList" :key="index" @click="getIndustria(k,1)">{{k.label}} </li>
                            </ul>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="yghu"><el-checkbox @change="getIndustria(null,2)" v-model="outClean">{{$t('other.a3102')}}</el-checkbox></div>
            <div class="yghu"><el-checkbox @change="getIndustria(null,3)" v-model="Staging">{{$t('other.a3103')}}</el-checkbox> </div>
            <!-- <div class="video" @click="toVideoMaterial">{{$t('other.a3104')}}</div> -->
            <div style="margin-left: 10px;">{{$t('other.a3105')}}</div>
            <el-select size="mini" v-model="params.categoryName" placeholder="" @change="selSearch()">
                <el-option
                    v-for="item in categoryArr"
                   :key="item"
                   :label="item==''?$t('other.a113'):item"
                   :value="item">
               </el-option>
           </el-select>
           <div class="yghu" style="margin-left:20px;"><el-checkbox @change="getIndustria(null,4)" v-model="FreeSamples">{{$t('other.a3106')}}</el-checkbox> </div>
           <div class="yghu" style="margin-left:20px;" v-if="false"><el-checkbox @change="getIndustria(null,5)" v-model="multiLevelDistribution">{{$t('other.a3307')}}</el-checkbox> </div>
        </div>    
        <div class="mkij">
            <div class="enjoyGoods" @click="openTab">{{$t('other.a3107')}}</div>
            <el-select style="width:130px;margin-right:10px;" size="medium" v-model="searchType" @change="typeBysearch()" >
                <el-option key="itemSku" :label="$t('other.a3108')" value="itemSku"> </el-option>
                <el-option key="groupName" :label="$t('other.a3109')" value="groupName"> </el-option>
                <el-option key="cusCode" :label="$t('other.a3110')" value="cusCode"> </el-option>
            </el-select>
            <el-input :type="searchType == 'cusCode'?'number':'text'" size="medium" style="width:250px;" clearable v-model="searchCode" :placeholder="textDesc"></el-input>
            <el-button style="margin-left:10px" size="medium" type="primary" @click="search()">{{$t('other.a245')}}</el-button>
        </div>
      </div>
      <div class="tggd">
          <div :class="{'ingks':true,'isActive':item.checked}" @mouseenter="item.checked=true" @mouseleave="item.checked=false" v-for="(item,index) in publicList" :key="index">
              <div class="oning" >
                <div @click="viewItem(item)">
                    <div  :class="{'imgBBX':true}"><img :class="{'active':item.checked}" :src="item.image" /></div>
                    <div class="groupName">{{item.groupName}}</div>
                    <div class="descItem" style="margin:10px 0 5px 0">
                        <div class="opyh poik" style="font-size:16px;font-witght:bold;">{{item.itemSku}}</div>
                        <div class="gyhv opyh ">{{$t('other.a735')}}</div>
                    </div>
                    <div class="descItem" >
                        <div class="opyh" style="color:red"><span v-show="item.minGrossProfitRate !== item.maxGrossProfitRate && item.minGrossProfitRate !== 0">{{item.minGrossProfitRate}}~</span>{{item.maxGrossProfitRate}}%</div>
                        <div class="gyhv opyh">{{$t('other.a3112')}}</div>
                    </div>
                    <div class="descItem" >
                        <div class="gyhv"><span>￥</span><span v-show="item.minPrice !== 0 && item.minPrice !== item.maxPrice">{{item.minPrice.toFixed(2)}}~</span>{{item.maxPrice.toFixed(2)}}</div>
                        <div class="gyhv opyh">{{$t('other.a3113')}}
                            <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                                <i class="el-icon-question oook"></i>:
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="descItem">
                        <div class="gyhv"><span>￥</span>{{item.store.storeType == 2 ? $t('other.a3115') : item.country==="0"?'6~7': item.country==="CN"?'1~2' : '3~4'}}</div>
                        <div class="opyh">{{$t('other.a3114')}}
                            <el-tooltip class="item" effect="dark" :content="$t('other.a3111')" placement="top-start">
                                <i class="el-icon-question oook"></i>:
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="descItem">
                        <div class="gyhv"><span>￥</span>{{item.maxWholesalePrice== 0 ? '--' : item.maxWholesalePrice}}</div>
                        <div class="opyh">{{$t('other.a1464')}}
                            <el-tooltip class="item" effect="dark" :content="$t('other.a2485')" placement="top-start">
                                <i class="el-icon-question oook"></i>:
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <div class="descItem" style="margin-top:10px">
                  <div class="opyh"><span style="color:#409eff;cursor: pointer;" @click="remote(item)">{{contryName[item.country]}}{{$t('other.a1741')}}</span></div>
                </div>
                <div class="descItem" >
                    <div class="opyh" style="color:#000;font-weight:bold;">{{$t('other.a3116')}}：{{item.amount >= 0 ? item.amount : 0}}</div>
                </div>
              </div>
              <div class="descItem">
                  <div class="opyh"><span></span>{{showStoreName(item.storeId)}}</div>
              </div>
        
              
              <div class="descItem" style="margin-top:10px">
                  
                  <div class="opyh">
                      <el-tooltip class="item" effect="dark" :content="item.userName" placement="top-start">
                        <span style="color:green;margin-right:5px;cursor: pointer;" @click="ContacChat(item)">{{$t('other.a3117')}}</span>
                        </el-tooltip>
                  </div>
                  <div class="opyh">
                      <!-- <span  class="disBgi" style="background-color:#409eff;cursor: pointer;margin-right:2px;" @click="customerDia=true">{{$t('other.a1704')}}</span> -->
                      <span v-if="item.freeDistribution"  class="disBgi" style="background-color:#409eff;margin-right:2px;">支持POD</span>
                      <!--  @click="GoFreeSamples(item)" -->
                      <span v-if="!item.agency" class="disBgi" @click="copyStoreItem(item)">{{$t('other.a1742')}}</span>
                      
                      <span v-if="item.agency" class="disBgiCOPY" >{{$t('other.a340')}}</span>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import utils from '../../../../utils/utils'
import api from '../../../../api/api'
import Dialog from '../../../../components/dialog/dialog.vue'
import newOrders from '../../../../api/moudles/newOrders'
import userStoreItems from "../../../../api/moudles/userStoreItems";
import distribution from "../../../../api/moudles/distribution";
import { mapState, mapActions, mapMutations } from "vuex";
import customerChat from '../../../../components/customerChat'
import {COUNTRY_AREA} from '../../../../config/config.js'
export default {
data(){
return{
    text:this.$t('other.a1724'),
    isActive:false,
    show:false,
    show1:false,
    showStore:false,
    showStore1:false,
    timer:null,
    timer2:null,
    purchaseDesc:this.$t('other.a3118'),
    customerDia:false,
    storeType:this.$t('other.a914'),
    num:0,
    outClean:false,
    textDesc:this.$t('other.a1739'),
    showTrue:false,
    searchCode:null,
    searchType:'groupName',
    Staging:false,
    FreeSamples:false,
    multiLevelDistribution:false,
    contryName:{},
    params:{
        belitId:null,
        storeId:null,
        clearInWarehouse:false,
        proportion:null,
        groupName:null,
        freeDistribution:false,
    categoryName:'',
    },
    // storeList:[{
    //     value:20100068,
    //     label: "马来雪兰莪仓(吉隆坡区域)"
    // },{
    //     value:20100008,
    //     label: "越南海外仓(河内)"
    // },],
    tableList:[],
    dialogVisible:false,
    storeItem:null,
    mainImg:{},
    categoryArr:[]
}
},
components:{
    customerChat,
    Dialog
},
props:{
    publicList:{
        type:Array,
        default:[]
    },
    industrialbelt:{
        type:Array,
        default:[]
    },
    storeList:{
        type:Array,
        default:[]
    },
},
watch:{
    searchCode(){
        console.log(this.searchCode)
        if(this.searchCode == ''){
            if(this.searchType == 'groupName'){
                this.params.groupName=null
            }
            if(this.searchType == 'cusCode'){
                this.params.cusCode=null
            }
            if(this.searchType == 'itemSku'){
                this.params.itemSku=null
            }
            this.$emit('refreshData',this.params)
        }
    }
},

computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      userName: (state) => state.shopaccess.userInfo.userName,
      userList: state => state.customer.userList,
      newList: state => state.customer.newList,
    }),

    cusCodeValue(){
      return JSON.parse(JSON.stringify(this.dataParams.name))
    }

  },
created(){
    this.contryName=COUNTRY_AREA
    this.getcate()
    console.log('industrialbelt',this.industrialbelt)
},
methods:{
    ...mapMutations('customer', [
      'updataUserList',
    ]),
    GoFreeSamples(item){
        console.log(item)
      this.$router.push({
        path: "/FreeSamples",
        query:{
            groupId:item.groupId
        }
      });
    },  
    getcate(){
        distribution.getcategory().then(res=>{
            if(res.code == 200){
                let arr = ['']
                arr.push(...res.data)
                this.categoryArr = arr
            }
        })
    },
    openTab(){
        window.open('https://www.yuque.com/docs/share/50584391-e4af-4ceb-8aca-ea171a433728  ')
    },

    copyStoreItem(item){
      console.log(item)
      item.userId=this.userId
      api
        .checkPayAgencyFee(item)
        .then(res => {
          console.log(res)
          if(res.code === 200) {
          let status = res.data
      this.$confirm(!status?this.$t('other.a3119'):this.$t('other.a3304'),this.$t("other.a142"),{
          confirmButtonText:this.$t('other.a145'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
      }).then(res => {
        api
        .copyStoreItem(item)
        .then(res => {
          if(res.code === 200) {
            this.$confirm(!status?this.$t('other.a3120'):this.$t('other.a3303'), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a955'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
              
            })

            console.log('desc',res.data)
            if(res.data.storeItems){
              res.data.storeItems.forEach(p => {
                p.synchrony=true
                this.updataSync(p)
              })
            }
            this.$emit('refreshData',this.params)
            
          }else{
            if(res.msg == '积分不足'&&!status){
            this.$message.warning(this.$t('other.a3300'))
            let self = this
            setTimeout(function(){
                self.$router.push({path:'/recharge'})
            },2000)
            }else{
            this.$message.warning(res.msg)
            }
          }
        })

        })
        }else{
              this.$message.warning(res.msg)
        }
      })
    },

    updataSync(ttp){
      userStoreItems
        .sellerUpdateSynchrony(ttp)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        console.log(res.msg)
        }
        })
    },

    typeBysearch(){
        console.log(this.searchType)
        if(this.searchType == 'groupName'){
            this.textDesc=this.$t('other.a1739')
        }
        if(this.searchType == 'cusCode'){
            this.textDesc=this.$t('other.a3121')
            this.searchCode = ''
        }
        if(this.searchType == 'itemSku'){
            this.textDesc=this.$t('other.a3122')
        }
       
    },

    search(){
        if(!this.searchCode){
            return
        }

        if(this.searchType == 'groupName'){
            this.params.groupName=this.searchCode
            this.params.cusCode=null
            this.params.itemSku=null
        }
        if(this.searchType == 'cusCode'){
            this.params.cusCode=this.searchCode
            this.params.groupName=null
            this.params.itemSku=null
        }
        if(this.searchType == 'itemSku'){
            this.params.itemSku=this.searchCode
            this.params.groupName=null
            this.params.cusCode=null
        }
        
        this.$emit('refreshData',this.params)
        console.log(this.dataParams)

    },
    selSearch(){
        this.$emit('refreshData',this.params)
    },
    distrubtionGoods(item){
        console.log(item)
    },

    ContacChat(item){
      console.log(item)
      let list =[]
      this.userList.forEach(p => {
        if(p.userAccount == item.userId){
          list.push(p)
        }
      })

				if(!list.length){

          this.updataUserList({
						id:null,
						active:false,
						userName:item.userName,
						userAccount:item.userId,
						sessionInfo:this.$t('other.a1803')
					})
					

				}
			  this.receiveItems={
				  name:item.userId
				}
			
      this.showTrue=true   
    },

    getIndustria(item,num){
        if(num == 0){
            this.params.belitId= item ? item.id : null
            this.purchaseDesc=item ? item.industrialBelt : this.$t('other.a3123')
        }

        if(num == 1){
            this.params.storeId=item ? item.value : null
            this.storeType=item ? item.label : this.$t('other.a1846')
        }
        if(num == 2){
            this.params.clearInWarehouse=this.outClean
            
        }

        if(num == 3){
            this.params.proportion=this.Staging ?  0.3 : null
            
        }
        if(num == 4){
            this.params.freeDistribution=this.FreeSamples?this.FreeSamples:''
        }
        if(num == 5){
            this.params.multiLevelDistribution=this.multiLevelDistribution?this.multiLevelDistribution:''
        }
        

        console.log('params',this.params)
        this.$emit('refreshData',this.params)
    },

    showStoreName(id){
      return utils.showStoreName(id)
    },

    toVideoMaterial(){
        this.$router.push('/video_material')
    },





    hideMore(){
        setTimeout(() => {
            this.show=this.show1 ? true : false
        },100)
    },
    hideMoreCopy(){
        this.show=false
        this.show1=false
    },

    hideStore(){
        setTimeout(() => {
            this.showStore=this.showStore1 ? true : false
        },100)
    },
    hideStoreCopy(){
        this.showStore=false
        this.showStore1=false
    },

    remote(item){
    
    console.log(item)
    this.showLoading()
        api
        .getStoreItemByGroupId({groupId:item.groupId})
        .then(res => {
        if(res.code === 200 ){
        console.log('storeitem',res.data)
            this.storeItem=res.data
            this.mainImg.image=item.image
            this.mainImg.name=item.groupName
            this.mainImg.url='https://shopee.ph/~-i.' + this.storeItem.categoryData.shopId + '.' + this.storeItem.categoryData.itemId
            let falg=false
            for(let key in res.data.categoryData){
            console.log(res.data.categoryData[key])
            if(!res.data.categoryData[key]){
                falg=true
            }
            }
            console.log(falg)
            if(falg){
            this.$dialog.alert({
                message: this.$t('other.a1743'),
                title:this.$t("other.a142")
                });

            }

            if(!falg){
            let str='catid='+this.storeItem.categoryData.catId+'&itemid='+this.storeItem.categoryData.itemId+'&shopid='+this.storeItem.categoryData.shopId
            let url=utils.getSimilaryData(this.storeItem.country.toLowerCase(),str)
            this.conturyCode=this.storeItem.country.toLowerCase()

            newOrders
            .proxyHttps({
                type:0,
                url:url,
                headerMap:null,
            })
            .then(res => {
                this.hideLoading()
                this.tableList=res.data.sections.similar_product.data.ads
                let temp=null
                this.tableList.forEach(e => {
                    e.image=utils.getImageUrl(item.country,e.image)
                    let saleDays = utils.getMin(30, utils.getDayInterval(e.ctime))
                    if (saleDays === 0) {
                    temp = 0
                    } else {
                    let averagePrice = utils.calculateAveragePrice(
                        e.models,
                        e.currency,
                        e.price_max,
                        e.price_min,
                    )
                    temp = parseInt(
                        utils.calculateTotalSales(averagePrice, e.sold) / saleDays
                    )
                    }
                    e.surgeIndex = temp
                })
            
            this.dialogVisible=true
            console.log('11',this.tableList)
            })
            }
            
        }else{
        this.$message.warning(res.msg)
        }
        })
    

    },

        // 计算月销售额
        getMonthTotalSales(models, currency, price_max, price_min, sold) {

        let ttp=null
        if (models && models.length) {
            // 计算平均值
            let result = utils.calculateAverage(models, 'price')
            ttp =utils.parseRate(result, currency)
            
        }else{
            ttp= utils.parseRate((price_max + price_min) / 2, currency)
        }
        
        return parseInt(ttp * sold)
        },
        getLatestRMBPrice(price, currency) {
        return utils.parseRate(price, currency).toFixed(1)
        },
    //获取日期间隔
    getDayNum(time) {
        let added = new Date(time * 1000)
        let today = new Date()
        let dayNum = parseInt(Math.abs(today - added) / 1000 / 60 / 60 / 24)
        return dayNum
        
    },
    // 计算最低售价 原始价格
    getLatestOriginPrice(price) {
        return (price / 100000).toFixed(1)
        },
    //转化指数
    getConversionRate(sold, count) {
        if (count === 0) {
        return '0.00%'
        }
        return ((sold / count) * 100).toFixed(2) + '%'
    },
    getImageUrlCopy(contury,image){
      return utils.getImageUrl(contury,image)
    },

    toGoodsDetailPage(shopid, itemid,country) {
      console.log(country)
      const params={
        PHP:'https://shopee.ph/~-i.',
        THB:'https://shopee.co.th/~-i.',
        MYR:'https://shopee.com.my/~-i.'
      }
      let newUrl =params[country] + shopid + '.' + itemid
      window.open(newUrl)
    },

    viewItem(item){
      console.log(item)
      this.showLoading()
      api
      .getStoreItemByGroupId({groupId:item.groupId})
      .then(res => {
      if(res.code === 200 ){
      console.log('详情信息',res.data)
      let list=[]
      if(res.data.storeItems){
        res.data.storeItems.forEach(p => {
          if(p.putAway){
            list.push(p)
          }
        })
      }

      res.data.storeItems=list
      
      localStorage.setItem('storeItemDetail',JSON.stringify(res.data))
      this.$router.push({
        path:'/storeItemDetail',
        query:{
          obj:'/publicGoods'
        }
      })
      }else{
      this.message.warning(res.msg)
      }
      })


      
    },

    

   

    


}
}

</script>
<style lang='scss' scoped>
@import "~@assets/scss/mixins";
.publicGoodList{
    background-color: #fff;
    margin:20px  6px 0 0;

    .textDesc {
        position: absolute;
        top: 23px;
        width: 100%;
        margin: auto;
        text-align: center;
        color: #fff;
        font-size: 24px;
    }

    .beifenxi{

        /deep/ .el-dialog__header{
        padding: 65px 20px 10px;
        background: linear-gradient( 
        -180deg
        ,#f53d2d,#f63);
        
        }
    
        /deep/ .el-dialog__close{
        display: none;
        }
    }


    .ppom{
        position: relative;
    }

    .showMore{
        display: block!important;
    }

    .ulbox{
        font-size: 14px;
        position: absolute;
        top: 25px;
        padding: 12px 20px 6px;
        box-shadow: 0 0 8px 0 #f3f3f3;
        display: none;
        border-radius: 3px;
        width: 425px;
        min-height: 200px;
        background: #fff;
        z-index: 100;

        .ingl{
            padding: 10px 0;
            border-bottom: 1px solid #eee;

            .uiop{
                margin-right: 20px;
                padding-bottom: 10px
            }

            .uiop:hover{
                color: #FF6A00ed;
                
            }
            
        }
    }

    .tggd{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 44px;
        
    }

    .isActive{
        border: 1px solid red!important;
    }

    .ghbyg{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .desoring{
        display: flex;
        padding: 20px 0px;
        margin: 0 10px;
        border-bottom: 1px solid #eee;

        .yghu{
            margin-right: 25px;
            cursor: pointer;
        }

        .video{
            color:#66b1ff;
            cursor: pointer;
        }
        
    }

    .mkij{
        display: flex;
        align-items: center;
        margin-right: 30px;

        .enjoyGoods{
            color: red;
            cursor: pointer;
            margin-right: 10px;
        }
    }

    

    .ingks{
        width: 14rem;
        overflow: hidden;
        margin: 0.5rem;
        border: 1px solid #eee;
        box-sizing: border-box;
        padding: 2px;
        



        .oning{
            cursor: pointer;
        }

        
        

        .groupName{
            font-size: 12px;
            @include multiline-ellipsis();
            min-height: 33px;
        }

        .descItem{
            @include flex-between();
            font-size: 14px;
            margin-bottom: 2px;

            .opyh{
                font-size: 12px;
                color: #999;
                padding-bottom: 2px;
                
            }

            .poik{
                width: 10rem;
                @include ellipsis()
            }

            .disBgi{
                background-color: #2aa515;
                border-radius: 3px;
                padding: 0px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: 700;
                cursor: pointer;
            }

            .disBgiCOPY{
                background-color: #E6A23C;
                border-radius: 3px;
                padding: 0px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: 700;
                cursor: pointer;
            }
        }


        .imgBBX{
            width: 100%;
            height: 13rem;
            overflow: hidden;

            img{
                width: 100%;
                transition: all 0.6s;
            }
         

            .active{
                transform: scale(1.1);
            }
        }
        
    }
}
</style>